import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import isNullOrUndefined from '@adsk/bim360-matrix-react-helpers/es/isNullOrUndefined';
import SelectBox from '@adsk/bim360-matrix-react-select-box';
import TextFieldCore from '@adsk/bim360-matrix-react-text-field-core';
import {Behaviors as TextInputBehaviors} from '@adsk/bim360-matrix-react-text-input';
import FormField from '../common/FormField';
import {ISSUE_ATTRIBUTES_DATA_TYPES} from '../../constants/issue-attributes';

class IssueCustomAttributeField extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  parseValue(value) {
    return isNullOrUndefined(value) ? '' : value.toString();
  }

  onChange(value) {
    const {customAttribute} = this.props;
    const {id, dataType} = customAttribute;
    this.props.onChange(value, id, dataType);
  }

  getClassName() {
    switch (this.props.customAttribute.dataType) {
      default:
      case ISSUE_ATTRIBUTES_DATA_TYPES.TEXT:
        return 'IssueCustomAttributeField__text';
      case ISSUE_ATTRIBUTES_DATA_TYPES.PARAGRAPH:
        return 'IssueCustomAttributeField__multi-line-text';
      case ISSUE_ATTRIBUTES_DATA_TYPES.NUMERIC:
        return 'IssueCustomAttributeField__numeric-text';
      case ISSUE_ATTRIBUTES_DATA_TYPES.SINGLE_LIST:
        return 'IssueCustomAttributeField__single-select-list';
    }
  }

  renderTextInput() {
    const {value: unparsedValue, showFieldError, customAttribute, disabled} = this.props;
    const className = this.getClassName();
    const value = this.parseValue(unparsedValue);
    const multiline = customAttribute.dataType === ISSUE_ATTRIBUTES_DATA_TYPES.PARAGRAPH;
    const numeric = customAttribute.dataType === ISSUE_ATTRIBUTES_DATA_TYPES.NUMERIC;
    return (
      <TextFieldCore
        valid={!showFieldError}
        behavior={multiline ? TextInputBehaviors.MULTI_LINE : TextInputBehaviors.SINGLE_LINE}
        value={value}
        onChange={this.onChange}
        disabled={disabled}
        className={className}
        data-testid={className}
        placeholder={numeric ? i18n.t('customIssueAttributes.numericalPlaceholder') : null}
      />
    );
  }

  renderSingleSelectList() {
    const {value: unparsedValue, showFieldError, disabled, isRequired} = this.props;
    const value = this.parseValue(unparsedValue);
    const className = this.getClassName();
    return (
      <SelectBox
        className={className}
        options={this.props.customAttribute.metadata.list.options}
        value={{id: value}}
        invalid={showFieldError}
        labelKey="value"
        valueKey="id"
        menuClassName="IssueCustomAttributeField__single-select-list-menu"
        disabled={disabled}
        onChange={option => this.onChange(option?.id ?? null)}
        clearable={!isRequired}
      />
    );
  }

  renderCustomAttributeField() {
    switch (this.props.customAttribute.dataType) {
      case ISSUE_ATTRIBUTES_DATA_TYPES.TEXT:
      case ISSUE_ATTRIBUTES_DATA_TYPES.PARAGRAPH:
      case ISSUE_ATTRIBUTES_DATA_TYPES.NUMERIC:
        return this.renderTextInput();
      case ISSUE_ATTRIBUTES_DATA_TYPES.SINGLE_LIST:
        return this.renderSingleSelectList();
      default:
        return null;
    }
  }

  render() {
    const {customAttribute, isRequired, showFieldError, errorMessage, fieldRef} = this.props;
    const {id, title} = customAttribute;

    return (
      <FormField
        key={id}
        className="IssueCustomAttributeField"
        data-testid="IssueCustomAttributeField"
        labelText={title}
        isFieldMandatory={isRequired}
        showFieldError={showFieldError}
        errorMessageText={errorMessage}
        fieldRef={fieldRef}
      >
        {this.renderCustomAttributeField()}
      </FormField>
    );
  }
}

IssueCustomAttributeField.displayName = 'IssueCustomAttributeField';

IssueCustomAttributeField.propTypes = {
  customAttribute: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  showFieldError: PropTypes.bool,
  scrollableContainerClassName: PropTypes.string,
  errorMessage: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  fieldRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  container: PropTypes.object
};

IssueCustomAttributeField.displayName = 'IssueCustomAttributeField';

export default IssueCustomAttributeField;
